/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 19:43:00
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";

export default class UnitGroupApi {
	/**
	 * 查询列表
	 * @param {UnitConfigDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: PageDo={page_index: 1, page_size: 1000000}):Promise<ResultPageDo<{name: string, id: number}[]>> {
		return Api.post('/monitor/component_product/query', params)
    }
    static async searchDataType():Promise<Result<{name: string, id: number}[]>> {
		return Api.post('/monitor/monitoring/items/query')
	}
	/**
	 * 查询列表
	 * @param {{id: number}} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchRelation (component_product_id: number): Promise<Result<{name: string, component_id: number,polid: string}[]>> {
		return Api.post('/monitor/component/component_product/query', {component_product_id})
    }
    static async updateRelation (component_product_id: number,component_ids: number[]): Promise<Result<any[]>> {
		return Api.post('/monitor/relation/component_product_divisor/add', {component_product_id,component_ids})
	}
	/**
	 * 新增
	 * @param {UnitConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async add(name: string):Promise<Result<any>> {
		return Api.post('/monitor/component_product/add', {name})
	}

	/**
	 * 修改
	 * @param {UnitConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async update(name: string, component_product_id: number):Promise<Result<any>> {
		return Api.post('/monitor/component_product/edit', {name, component_product_id})
	}

	/**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async delete(factor_set_id	: number):Promise<Result<any>> {
		return Api.post('/monitor/component_product/delete', {factor_set_id	})
    }
}